module.exports = __webpack_public_path__ + "img/kyc-warning.547184b0.svg";